// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleFoundationLine_root__XQLi0","content":"ArticleFoundationLine_content__JK99O"};